<template>
  <div class="screen-style">
    <span class="style-name">{{ name }}：</span>
    <a href="#" @click.prevent="select(year)" v-for="year in list" :key="year.id">{{ year.name }}</a>
  </div>
</template>

<script>
  // import CommonModule from '@api/module/common/common/CommonModule'
  import { isEmpty } from 'lodash'

  export default {
    props: {
      list: {
        type: Array,
        default() {
          return []
        }
      },
      name: String,
      id: String
    },
    methods: {
      /**
       *@description 有路由的时候的特殊处理
       *@author lsh
       *@date 2020-08-19 11:51:38
       */
      queryAction() {
        if (isEmpty(this.$route.query)) {
          return
        }
        // todo wengpengfei
        //加载标志，没加载完就自己调自己
        // if (CommonModule.skuLoad) {
        //   const selectSku = JSON.parse(this.$route.query.selectSku),
        //     componentCode = camelCase(this.id.replace('sku-', '')),
        //     skuOptionId = selectSku.find(item => item.code == componentCode)?.id
        //   if (!skuOptionId) return
        //   const selectItme = this.list.find(item => item.id === skuOptionId)
        //   if (selectItme) {
        //     this.select(selectItme)
        //   } else {
        //     console.log('找不到对应sku选项不进行查找')
        //   }
        // } else {
        //   setTimeout(() => {
        //     this.queryAction()
        //   }, 0)
        // }
      },
      select(item) {
        this.$emit('input', [item])
      }
    },
    mounted() {
      this.queryAction()
    }
  }
</script>
